import { NameFormat, formatName } from 'src/utils/nameFormatting';
import { GroupMember } from '../../grouping';

/**
 * An item several members share is one item, so deleting it takes every member's copy. The
 * warning has to say so and name them: from one member's tab the other members are off screen,
 * and an adviser who reads "delete" as "delete mine" would take the others' records with it.
 */
export function deletionMessage(noun: string, members: GroupMember[]): string {
  const others = members.length > 1 ? names(members) : null;

  return others
    ? `This ${noun} is shared. Deleting it removes it for ${others}. This cannot be undone.`
    : `This permanently deletes this ${noun}. This cannot be undone.`;
}

function names(members: GroupMember[]): string {
  const formatted = members.map(member =>
    formatName(member.firstName, member.lastName, NameFormat.NATURAL),
  );
  const last = formatted.pop();

  return formatted.length > 0 ? `${formatted.join(', ')} and ${last}` : (last ?? '');
}
